import { FORM_ERROR } from 'final-form';
import React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

import { patchInboundMerchant } from 'apis/merchant-onboarding-service/api';

import { SsmoCountryConfig } from '../../SelfServeFormView/SelfServeSignUpForm/types';
import { SelfServeStepsIdentifiers } from '../constants';
import CommissionsForm from '../forms/ServicePricingForm/CommissionsForm';
import { CommissionsPreferences, CommissionsPreferencesSchema } from '../forms/validation';
import { validateStepParam } from '../helpers';
import { InboundMerchant } from '../types';

type ServicePricingProps = {
  inboundMerchant: InboundMerchant;
  ssmoCountryConfig: SsmoCountryConfig;
  goToNextStep: () => void;
  setUpdateIsInProgress: (inProgress: boolean) => void;
};

const Wrapper = styled.div``;

const CommissionsStep = ({
  inboundMerchant,
  ssmoCountryConfig,
  goToNextStep,
  setUpdateIsInProgress,
}: ServicePricingProps) => {
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);

  const handleCommissionsSubmit = async (
    values: CommissionsPreferences,
  ): Promise<{ [key: string]: string | Error } | void> => {
    try {
      setUpdateIsInProgress(true);
      const stepParam = validateStepParam(searchParams.get('step'));

      const validFormValues = CommissionsPreferencesSchema.validateSync(values);

      await patchInboundMerchant({ ...validFormValues, ssmoStepCompletionId: stepParam }, inboundMerchant.merchantId);
      goToNextStep();
    } catch (submitError) {
      return { [FORM_ERROR]: submitError as Error };
    } finally {
      setUpdateIsInProgress(false);
    }
  };

  return (
    <Wrapper>
      <CommissionsForm
        commissionConfig={ssmoCountryConfig.commissionsConfig}
        commissionsPreferences={{
          joinedToWoltPlus: inboundMerchant!.joinedToWoltPlus || false,
        }}
        handleSubmit={handleCommissionsSubmit}
        formId={SelfServeStepsIdentifiers.ServicePricing}
      />
    </Wrapper>
  );
};

export default CommissionsStep;
